/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminProductList,
    AdminProductListFromJSON,
    AdminProductListFromJSONTyped,
    AdminProductListToJSON,
} from './AdminProductList';

/**
 * 
 * @export
 * @interface AdminProductListResp
 */
export interface AdminProductListResp {
    /**
     * 
     * @type {Array<AdminProductList>}
     * @memberof AdminProductListResp
     */
    items?: Array<AdminProductList>;
    /**
     * 
     * @type {number}
     * @memberof AdminProductListResp
     */
    total?: number;
}

export function AdminProductListRespFromJSON(json: any): AdminProductListResp {
    return AdminProductListRespFromJSONTyped(json, false);
}

export function AdminProductListRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductListResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(AdminProductListFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function AdminProductListRespToJSON(value?: AdminProductListResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': !value.items ? undefined : ((value.items as Array<any>).map(AdminProductListToJSON)),
        'total': value.total,
    };
}

